import { useNavigate } from "react-router-dom";

import { PermissionsEnum } from "@/auth/interfaces";
import {
  ROUTER_PATHS,
  TABLE_CONSTANTS_COLUMS,
  useCheckPermissions,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import { getPlanificadores, useFetchFlotas } from "@/shared/actions/erp";
import { GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import { AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { useTableColumnsFlotas } from "@/erp/mantenimiento-operacion/flotas/shared/hooks";
import { Flota } from "@/shared/interfaces/erp/mantenimiento-operaciones";
import { usePlanificadorStore } from "@/store/erp";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { Edit } from "@mui/icons-material";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";

export type FlotasPageProps = {};

const PlanificadoresPage: React.FC<FlotasPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_planificador);

  const returnUrlPlanificadoresPage =
    ROUTER_PATHS.mantenimientoOperaciones.planificadorNav;

  const navigate = useNavigate();

  // server side filters - colums table
  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const setSelectedFlota = usePlanificadorStore((s) => s.setSelectedFlota);

  ///* global state -----------------------
  const setAlert = useUiStore((s) => s.setAlert);
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);

  ///* table -----------------------
  const { pagination, searchTerm, setPagination } = useTableFilter();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: flotasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchFlotas({
    page: pageIndex + 1,
    page_size: pageSize,
    nombre: searchTerm,
    ...filterObject,
    estado: true,
  });

  ///* handlers
  const onEdit = async (original: Flota) => {
    setIsGlobalLoading(true);
    const res = await getPlanificadores({ flota: original.codigo });
    const lastPlanificadorData = res?.data?.data; // 'cause is ordered by date
    //return;

    if (!lastPlanificadorData || res.data.count === 0) {
      setAlert(
        true,
        "No hay planificadores para esta flota, cree uno manualmente",
        AlertSeverityEnum.error
      );
      setIsGlobalLoading(false);
      return;
    }
    setIsGlobalLoading(false);
    setSelectedFlota(lastPlanificadorData.at(0)?.flota_data!);
    navigate(`${returnUrlPlanificadoresPage}/horario/${original.id_flota}`);
  };

  const onCreatePlanificador = async (original: Flota) => {
    //setModalCreatePlanificador(true)
    navigate(`${returnUrlPlanificadoresPage}/crear/${original.id_flota}`);
  };

  ///* columns
  const { columnsPlanificador } = useTableColumnsFlotas({
    enableStateSwitch: false,
  });

  return (
    <SingleTableBoxScene
      title="Planificador de flotas"
    >
      <GeneralTable<Flota>
        columns={columnsPlanificador}
        data={flotasPagingRes?.data?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={flotasPagingRes?.data?.count}
        ///* filters - server side
        enableManualFiltering={true}
        enableSorting={false}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableGlobalFilter={false}
        ///* Actions
        enableEditing={true}
        canEdit={false}
        showCustomActionBtnSpace={true}
        enableColumnActions={true}
        actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL}
        customActionBtnSpace={(value) => {
          return (
            <Grid container>
              <Grid item>
                <Tooltip title={"Editar"} >
                  <IconButton 
                  color="inherit"
                  onClick={() => onEdit(value)}>
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Grid>

              <Grid item>
                <Tooltip title={"Crear Planificador"} >
                  <IconButton color="primary" onClick={() => onCreatePlanificador(value)}>
                    <InsertInvitationIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          );
        }}
      />
    </SingleTableBoxScene>
  );
};

export default PlanificadoresPage;
